import React from "react";
import PropTypes from "prop-types";
import { Navigate } from "react-router-dom";

// NOTE (Dag 7): this guard is UX only — it hides screens the user's role should
// not see. It is NOT a security boundary: `role` lives in localStorage and is
// user-editable. Every sensitive action is independently authorized on the
// backend by the signed JWT (see connect.js authorize() + per-resource ownership
// checks). Never rely on this component to protect data.
const ProtectedRoute = ({ element, allowedRoles }) => {
  const role = localStorage.getItem("role");

  if (!role) {
    return <Navigate to="/authentication/log-in" />;
  }

  const isAllowed = allowedRoles.includes(role);

  return isAllowed ? element : <Navigate to="/authentication/log-in" />;
};

ProtectedRoute.propTypes = {
  element: PropTypes.element.isRequired,
  allowedRoles: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default ProtectedRoute;
